(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["timeline"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('click', function(event) {
  const navButtons = document.querySelectorAll('.Timeline__NavItem');
  const viewAllButton = document.querySelector('.Timeline__ButtonWrapper a');

  navButtons.forEach(button => button.addEventListener('click', function() {
    const selectedIndex = this.dataset.index;
    const projectLinks = [
      '/pages/latest-projects', // Link for "Latest"
      'pages/inside-uae', // Link for "Inside UAE"
      '/pages/outside-uae' // Link for "Outside UAE"
    ];
    viewAllButton.href = projectLinks[selectedIndex];
  }));
});

  } catch(e) { console.error(e); }
})();

})();
